import Label from "../../../../../components/Modules/Label";
import {
  MultiChoice,
  MultiChoiceTwo,
} from "../../../../../components/Modules/MultiChoice";
import { MultiChoiceProps } from "../../types/SurveyTypes";

export const MultiChoiceProp: React.FC<MultiChoiceProps> = ({
  options,
  question,
  required,
  actionId,
  selectedOptions,
  handleCheckboxChange,
  themeManager,
  multiChoiceModal,
}) => {
  return (
    <div>
      <Label htmlFor="textAreaInput" style={themeManager.getLabelStyles()}>
        {`${question}${required === true ? "*" : ""}`}
      </Label>
      {multiChoiceModal === "modal1" ? (
        <MultiChoiceTwo
          options={options}
          checked={
            selectedOptions && Array.isArray(selectedOptions[actionId])
              ? selectedOptions[actionId]
              : undefined
          }
          onChange={(e) => {
            handleCheckboxChange(e.target.value, actionId);
          }}
          style={themeManager.getMultiChoiceBorderStyle()}
          selectedStyle={themeManager.getMultiChoiceSelectedColorStyles()}
        />
      ) : (
        <div style={{ width: "90%" }}>
          <MultiChoice
            options={options}
            checked={selectedOptions[actionId]}
            onChange={(e: any) => handleCheckboxChange(e.target.value, actionId)}
            style={themeManager.getMultiChoiceStyles()}
            selectedStyle={themeManager.getMultiChoiceSelectedStyles()}
          />
        </div>
      )}
    </div>
  );
};
